// The two type roles every pause screen is built from (screen-mock
// `#pauseBody h3`, `#pauseBody p`), plus the label half of a `SettingRow`.
//
// Here rather than in the kit because they are this screen's voice, not the
// language's: a heading inside the pause plate and a heading on a card are
// different sizes for different reasons, and a shared primitive would have to
// carry both.

import { styled } from "../kit";

/** A screen's title. Heading voice — it names a thing. */
export const ScreenTitle = styled("h3")(({ theme }) => ({
  margin: `0 0 ${theme.kit.space.sm}px`,
  fontFamily: theme.kit.font.heading,
  fontWeight: 400,
  fontSize: 20,
  letterSpacing: ".4px",
  color: theme.kit.color.cream
}));

/**
 * A paragraph of explanation.
 *
 * `56ch` because a measure is a reading control, not a layout one — the plate
 * is 760px wide and a line that ran its whole width would be unreadable.
 */
export const Copy = styled("p")(({ theme }) => ({
  margin: `0 0 ${theme.kit.space.sm}px`,
  color: theme.kit.color.inkDim,
  fontSize: 13,
  lineHeight: 1.55,
  maxWidth: "56ch"
}));

/**
 * The label side of a `SettingRow`.
 *
 * `off` is for a row whose control is disabled: the switch already says so, and
 * a label that stays bright beside a dead switch reads as the switch being
 * broken rather than as the setting being unavailable.
 */
export const RowLabel = styled("span", {
  shouldForwardProp: (prop: string) => prop !== "off"
})<{ off?: boolean }>(({ off }) => ({
  opacity: off ? 0.45 : 1
}));
